module.exports = __webpack_public_path__ + "/static/assets/d61429ad96a25ec2917ebc77d900aae0.svg";